import GhostBumpIcon from './GhostBumpIcon';
import CoreboundIcon from './CoreboundIcon';

const RelicIcon = ({ relicId, className }) =>
  relicId === 'ghostBump' ? (
    <GhostBumpIcon className={className || 'coreboundGhostBumpIcon'} />
  ) : (
    <CoreboundIcon name={relicId || 'relic'} className={className} />
  );

export default RelicIcon;
